<greco-simple-dialog [data]="dialogData"></greco-simple-dialog>
